import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";
import { languageHelper } from "../../../../config/helperFunctions";



function FoodSalesReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [columns] = useState([
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },

    // {
    //   header: "Date",
    //   accessorKey: "Date",
    // },
    {
      header: languageHelper("Name") || "Name",
      accessorKey: "product_name",
    },
    {
      header: languageHelper("Name Arabic") || "Name Arabic",
      accessorKey: "product_name_arabic",
    },
    {
      header: languageHelper("Quantity") || "Quantity",
      accessorKey: "total_sales_qty",
    },
  ]);

  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const handleCatSelect = (e) => {
    setSelectedCategory(e.value);
  };

  const selectButton = [
    {
      placeholder: languageHelper("Category"),
      options: categories,
      onChange: handleCatSelect,
    },
  ];

  
    const [selectedOutlet, setSelectedOutlet] = useState();
    const handleOutletSelect = (e) => {
      setSelectedOutlet(e.value);
    };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/categories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCat = res.data.map((cat) => ({
          value: cat.id,
          label: cat.category_name,
        }));
        setCategories(mappedCat);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error Occured!");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/items-sales-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          category_id: selectedCategory,
          start_date: startDate,
          end_date: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [endDate, selectedCategory, selectedOutlet, startDate, user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Food Sales Report")}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        // buttonDataa={buttonDataa}
        selectButton={selectButton}
        downloads={true}
        handleOutletSelect={handleOutletSelect}
      />
    </main>
  );
}

export default FoodSalesReport;
